const ActionTypes = {
    NavigateWithValidation: 'NAVIGATE_WITH_VALIDATION',
    SetFormFromManifest: 'SET_FORM_FROM_MANIFEST',
    SetFormFromUrl: 'SET_FORM_FROM_URL',
    SubmitForm: 'SUBMIT_FORM',
    ToggleModal: 'TOGGLE_MODAL',
};

const MutationTypes = {
    AuthorizeNavigateFromRoute: 'AUTHORIZE_NAVIGATE_FROM_ROUTE',
    SetManifestServiceStatus: 'SET_MANIFEST_SERVICE_STATUS',
    SetForm: 'SET_FORM',
    SetConfirmationId: 'SET_CONFIRMATION_ID',
    SetSubmitFormHasBeenAttempted: 'SET_SUBMIT_FORM_HAS_BEEN_ATTEMPTED',
    SetRouterIsInitialized: 'SET_ROUTER_IS_INITIALIZED',
    SetRouteArray: 'SET_ROUTE_ARRAY',
    SetRouteValidationState: 'SET_ROUTE_VALIDATION_STATE',
    SetLanguage: 'SET_LANGUAGE',
    UpdateValue: 'UPDATE_VALUE',
    UpdateError: 'UPDATE_ERROR',
};

const ManifestServiceStatus = {
    Up: 'UP',
    Loading: 'LOADING',
    Error: 'ERROR',
};

const RouteState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    NotVisited: 'NOT_VISITED',
};

export {
    MutationTypes,
    ActionTypes,
    ManifestServiceStatus,
    RouteState,
};



// WEBPACK FOOTER //
// ./source/framework/instance/store.constants.js